import { useState } from 'react';
import {
    obtenerFamiliaresPorEmpleado,
    agregarFamiliarAEmpleado,
    actualizarFamiliarEmpleado,
    eliminarFamiliarDeEmpleado
} from '../../../services/empleado/empleadoDetalleService';

// Helper para extraer IDs (puedes moverlo a un utils.js compartido)
const extraerId = (dato) => {
    if (!dato) return null;
    if (typeof dato === 'object' && dato.configuracionDetId) return dato.configuracionDetId;
    if (!isNaN(parseInt(dato))) return parseInt(dato);
    return dato;
};
const convertirFecha = (f) => {
    if (!f) return null;
    if (Array.isArray(f)) return new Date(f[0], f[1] - 1, f[2]);
    if (typeof f === 'object' && f.year) return new Date(f.year, f.monthValue - 1, f.dayOfMonth);
    if (typeof f === 'string') return new Date(f);
    return new Date(f);
};
const emptyFamiliar = {
    id: null, nombre: '', tipoDoc: null, identificador: '',
    tipoFamiliar: null, parentesco: null, fechaNacimiento: null,
    esCargaFamiliar: false, aplicaUtilidad: false
};

export const useFamiliares = ({ empleadoId, toast }) => {
    const [familiares, setFamiliares] = useState([]);
    const [familiarData, setFamiliarData] = useState(emptyFamiliar);


    const [familyDialog, setFamilyDialog] = useState(false);
    const [loading, setLoading] = useState(false);

    const mapearFamiliar = (f) => {
        let fechaParsed = null;
        if (f.fecha) {
            if (typeof f.fecha === 'object' && f.fecha.year) {
                fechaParsed = new Date(f.fecha.year, f.fecha.monthValue - 1, f.fecha.dayOfMonth);
            } else if (Array.isArray(f.fecha)) {
                fechaParsed = new Date(f.fecha[0], f.fecha[1] - 1, f.fecha[2]);
            } else {
                const d = new Date(f.fecha);
                if (!isNaN(d.getTime())) {
                    const offset = d.getTimezoneOffset() * 60000;
                    fechaParsed = new Date(d.getTime() + offset);
                }
            }
        }

        return {
            id: f.familiarId,
            nombre: f.nombre,
            identificador: f.identificador,
            fechaNacimiento: fechaParsed,
            esCargaFamiliar: f.esCargaFamiliar || false,
            tipoDoc: f.tipoIdentificadorConfDetId || extraerId(f.tipoIdentificadorConfDet),
            tipoFamiliar: f.tipoFamiliarConfDetId || extraerId(f.tipoFamiliarConfDet),
            parentesco: f.parentescoConfDetI || extraerId(f.parentescoConfDet),
            aplicaUtilidad: f.aplicaUtilidad || false
        };
    };

    const recargarFamiliares = async (id) => {
        if (!id) { setFamiliares([]); return; }
        try {
            const nuevosFamiliares = await obtenerFamiliaresPorEmpleado(id);

            const formateados = nuevosFamiliares.map(f => ({
                id: f.familiarId,
                nombre: f.nombre,
                identificador: f.identificador,
                parentesco: f.parentescoConfDet?.nombre || f.parentesco,
                tipoFamiliar: f.tipoFamiliarConfDet?.nombre ?? '',
                fechaNacimiento: convertirFecha(f.fecha),
                esCargaFamiliar: f.esCargaFamiliar,
                aplicaUtilidad: f.aplicaUtilidad,
                tipoIdentificadorConfId: f.tipoIdentificadorConfDet?.configuracionDetId ?? null,
                tipoFamiliarConfId: f.tipoFamiliarConfDet?.configuracionDetId ?? null,
                parentescoConfId: f.parentescoConfDet?.configuracionDetId ?? null,
            }));
            setFamiliares(formateados);
        } catch (e) { console.error(e); }
    };

    const openNewFamiliar = () => {
        setFamiliarData(emptyFamiliar);
        setFamilyDialog(true);
    };

    const openEditFamiliar = (rowData) => {
        setFamiliarData({ ...rowData });
        setFamilyDialog(true);
    };

    const saveFamiliar = async () => {
        if (loading) return false;
        if (!empleadoId) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Guarde el empleado primero' });
            return false; // Retornamos éxito/fallo
        }

        const formatDate = (d) => d && d.toISOString ? d.toISOString().split('T')[0] : null;

        /*const payload = {
            empleadoId,
            nombre: familiarData.nombre,
            tipoIdentificadorConfDetId: familiarData.tipoIdentificadorConfId,
            tipoFamiliarConfDetId: familiarData.tipoFamiliarConfId,
            parentescoConfDetI: familiarData.parentescoConfId,
            identificador: familiarData.identificador,
            fecha: formatDate(familiarData.fechaNacimiento),
            adjuntoUrl: "sin-adjunto",
            esCargaFamiliar: familiarData.esCargaFamiliar || false,
            aplicaUtilidad: familiarData.aplicaUtilidad || false
        };*/
        const payload = {
            empleadoId,
            nombre: familiarData.nombre,
            tipoIdentificadorConfDetId: familiarData.tipoDoc,
            tipoFamiliarConfDetId: familiarData.tipoFamiliarId,
            parentescoConfDetI: familiarData.parentescoId,
            identificador: familiarData.identificador,
            fecha: formatDate(familiarData.fechaNacimiento),
            adjuntoUrl: "sin-adjunto",
            esCargaFamiliar: familiarData.esCargaFamiliar || false,
            aplicaUtilidad: familiarData.aplicaUtilidad || false
        };

        try {
            setLoading(true);
            if (familiarData.id) await actualizarFamiliarEmpleado({ ...payload, familiarId: familiarData.id });
            else await agregarFamiliarAEmpleado(payload);

            toast.current.show({ severity: 'success', summary: 'Éxito' });
            await recargarFamiliares(empleadoId);
            setFamilyDialog(false);
            setFamiliarData(emptyFamiliar);
            return true; // Guardado OK
        } catch (e) {
            toast.current.show({ severity: 'error', summary: 'Error' });
            return false;
        } finally {
            setLoading(false);
        }
    };

    const deleteFamiliar = async (rowData) => {
        if (!window.confirm("¿Eliminar?")) return;
        try {
            await eliminarFamiliarDeEmpleado(rowData.id);
            toast.current.show({ severity: 'success', summary: 'Eliminado' });
            await recargarFamiliares(empleadoId);
        } catch (e) {
            toast.current.show({ severity: 'error', summary: 'Error' });
        }
    };

    return {
        familiares,
        familiarData,
        setFamiliarData,
        setFamiliares,
        familyDialog,
        setFamilyDialog,
        recargarFamiliares,
        openNewFamiliar,
        openEditFamiliar,
        saveFamiliar,
        deleteFamiliar,
        mapearFamiliar,
        loading
    };
};